import { render, staticRenderFns } from "./inbox-email-log-card.vue?vue&type=template&id=2ccd1cd3&scoped=true&"
import script from "./inbox-email-log-card.vue?vue&type=script&lang=js&"
export * from "./inbox-email-log-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd1cd3",
  null
  
)

export default component.exports